const scrollToTop = (offset = 200) => {
  const top = 0 - offset; // Adjust for offset
  window.scrollTo({
    top,
    behavior: 'smooth',
  });
};

export default scrollToTop;
